<template>
  <div id="app">
    <app-nav v-if="$store.state.user"></app-nav>
    <router-view></router-view>
    <div onclick="Tawk_API.toggle()" class="c-chat-circle">
      <i class="icon24-chatting-white"></i>
      <div class="c-chat-circle__text" id="chat-circle-text">&nbsp; &nbsp; &nbsp; Chat hỗ trợ &nbsp; &nbsp;
        &nbsp;
      </div>
    </div>
    <web-phone v-if="$store.state.user && !$store.state.inApp"></web-phone>
    <app-phone v-if="$store.state.user && $store.state.inApp"></app-phone>
    <new-issue v-if="$store.state.user && $store.state.user.permissions.includes('issueEnabled')"></new-issue>
    <title-notification></title-notification>
  </div>
</template>

<script>
import Nav from "./components/Nav";
import TitleNotification from "./components/TitleNotification";
import Socket from "./mixins/Socket";
import Roles from "./mixins/Roles";
import WebPhone from "./components/Phone";
import AppPhone from "@/components/AppPhone";
import console from 'console';
import NewIssue from "@/views/1022/NewIssue";

export default {
  mixins: [Socket, Roles],
  components: {
    NewIssue,
    AppPhone,
    WebPhone,
    TitleNotification,
    'app-nav': Nav,
  },
  data: function () {
    return {
      refreshing: false,
      registration: null,
      updateExists: false
    }
  },
  methods: {
    refreshApp() {
      this.updateExists = false;
      if (!this.registration || !this.registration.waiting) {
        return;
      }
      this.registration.waiting.postMessage('skipWaiting');
    },
    showRefreshUI(e) {
      this.registration = e.detail;
      this.updateExists = true;
      if (this.updateExists) {
        this.$swal({
          title: 'New Version of Callio available!',
          text: 'Press OK to update!',
          icon: "success",
          showCancelButton: true,
          backdrop: false
        }).then((result) => {
          if (result.value) {
            this.refreshApp();
          }
        });
      }
    },
    deviceMessage(msg) {
      try {
        if (msg) {
          let data = JSON.parse(msg);
          if (data.type === "load") {
            this.$store.commit('inApp', true);
          } else if (data.type === "updateToken") {
            this.$bgService.post('/profile/device-token', {
              token: this.$store.state.token,
              apnToken: data.data.apnToken,
              firebaseToken: data.data.firebaseToken,
              deviceType: data.data.deviceType,
              ua: data.data.ua
            }).then((response) => {
              console.log(response.data);
            }).catch(err => {
              console.log(err)
            });
          } else {
            this.$bus.$emit('deviceMessage', msg);
          }
        }
      } catch (ex) {
        console.log(ex);
      }
    }
  },
  created() {
    window.deviceMessage = this.deviceMessage;
    if ((window.webkit && window.webkit.messageHandlers.iOSNative) || window.androidNative) {
      this.$store.commit('inApp', true);
    }
  },
  mounted() {
    window.addEventListener("message", (msg) => {   // Message from IOS
      if (msg.data) {
        this.deviceMessage(msg.data);
      }
    }, false);
    document.addEventListener("message", (msg) => {     // Message from android
      if (msg.data) {
        this.deviceMessage(msg.data);
      }
    }, false);
    if (!this.$store.state.inApp && this.$notification) {
      this.$notification.requestPermission();
    }
    document.addEventListener(
        'swUpdated', this.showRefreshUI, {once: true}
    );
    navigator.serviceWorker.addEventListener(
        'controllerchange', () => {
          if (this.refreshing) return;
          this.refreshing = true;
          window.location.reload();
        }
    );
    setTimeout(() => {
      const Tawk_API = Tawk_API || window.Tawk_API || null;
      if (Tawk_API && this.$store.state.user) {
        Tawk_API.setAttributes({
          'name': `${this.$store.state.user.name} (${this.$store.state.user.ext}@${this.$store.state.user.client.domain})`,
          'email': `${this.$store.state.user.email}`,
          'hash': this.$store.state.user._id
        }, function () {
        });
      }
    }, 3000);
  }
};
</script>

<style lang="scss">
@import './assets/sass/main';
</style>






















